import React, { useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { ImSpinner2 } from "react-icons/im";
import { HouseContext } from "../../context/HouseContext";
import House from "../../components/House/House";
import { Helmet } from "react-helmet";

const PropertyType = () => {
  const { type } = useParams(); // Recibe el parámetro de tipo desde la URL
  const { houses, loading } = useContext(HouseContext);
  const [visibleHouses, setVisibleHouses] = useState(6); // Mostrar 6 casas inicialmente

  // Filtra las casas por el tipo (si existe el parámetro 'tipe')
  const filteredHouses = type
    ? houses.filter((house) => house.state === type) // Ajusta el campo `type` según cómo esté estructurado tu objeto
    : houses;

  const showMoreHouses = () => {
    setVisibleHouses((prevVisibleHouses) => prevVisibleHouses + 6);
  };

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <ImSpinner2 className="animate-spin text-primary text-5xl mb-4" />
        <h2 className="text-primary text-2xl ml-4">Cargando Propiedades...</h2>
      </div>
    );
  }

  if (!loading && houses.length === 0) {
    return (
      <div className="flex justify-center items-center text-center text-3xl text-primary my-[200px] h-[60vh]">
        Lo sentimos, no hemos encontrado resultados
      </div>
    );
  }

  // Verificar si no hay casas después de que `houses` ya tiene datos
  if (!loading && houses.length > 0 && filteredHouses.length < 1) {
    return (
      <div className="text-center text-3xl text-primary my-[200px]">
        Lo sentimos, no hemos encontrado resultados
      </div>
    );
  }

  return (
    <section className="bg-[#293445] py-32 px-2">
      <div className="flex justify-center items-center w-full flex-col mb-4">
        <h2 className="text-white text-4xl font-bold">
          NUESTRAS PROPIEDADES EN{" "}
          <span className="uppercase text-primary">{type}</span>
        </h2>
        <h3 className="text-white text-lg mt-4">
          {" "}
          Conocé las propiedades más destacadas del mercado. La mejor y más
          exclusiva selección de propiedades en venta y alquiler.
        </h3>
      </div>
      <Helmet>
        <title>
          {type ? `Propiedades en ${type}` : "Todas las Propiedades"}
        </title>
        <meta
          name="description"
          content={`Explora las propiedades en ${
            type || "nuestra plataforma"
          } para encontrar la casa ideal. Verifica opciones de ${
            type || "tipos de propiedad"
          } disponibles.`}
        />
        <meta
          name="keywords"
          content={`propiedades, ${
            type ? type : "casas"
          }, alquiler, venta, compra, inmuebles`}
        />
      </Helmet>
      <div className=" mx-auto max-w-[1500px]">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-14 justify-center">
          {filteredHouses.slice(0, visibleHouses).map((house, index) => (
            <Link to={`/propiedad/${house.id}`} key={index}>
              <House house={house} />
            </Link>
          ))}
        </div>
        {visibleHouses < filteredHouses.length && (
          <div className="text-center mt-8">
            <button
              onClick={showMoreHouses}
              className="bg-primary text-white px-4 py-2 rounded hover:opacity-80"
            >
              Ver más Propiedades
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default PropertyType;
